import React from 'react';
import ReplyContainer from './ReplyContainer';
import { Conversation } from '../../../model/domain/messaging';

interface ReplyScreenProps {
    conversation: Conversation; 
    onClose: () => void; 
}

class ReplyScreen extends React.Component<ReplyScreenProps> {
    
    public render() {
        const { conversation, onClose } = this.props;
        return <ReplyContainer conversation={conversation} onClose={onClose}/>

    }
}

export default ReplyScreen;
